import React, {useEffect, useState} from "react";
import Api from "../../servicios/api/Api";
import libToast from "../../lib/LibToast";
import TipoEseTable from "./TipoEseTable";
import UsuariosResecTable from "./UsuariosResecTable";
import EseTable from "../ese-index/EseTable";
import AddEse from "./AddEse";


const apiCliente = Api.getApiCliente();
const Home = () => {
  
  const [att, setAtt] = useState({isLoading: true})
  const [eseLast, setEseLast] = useState([])
  
  
  useEffect(() => {
    //cargar datos del api
    
    (async () => {
      const response = await apiCliente.home();
      if (!response.success) {
        libToast.alert("Error " + response.message);
      }
      setAtt(response.data);
      setEseLast(response.data["ese-last"]);
    })()
    
  }, []);
  
  const onEseInserted = (ese) => {
    setEseLast([ese, ...eseLast]);
    
  }
  
  return (
    <div className="">
      
      <AddEse listaTipo={att["ese-tipo"]}
              onEseInserted={onEseInserted}/>
      
      
      <h2 className="subtitle">
        <i className="fa fa-files-o m10R"/>
        Últimos 10 Estudios
      </h2>
      
      <EseTable list={eseLast}/>
      
      <hr/>
      <div className="tile is-flex-desktop p10T">
        <div className="flexGrow1 container">
          <TipoEseTable list={att["ese-tipo"]}/>
        </div>
        <div className="flexGrow1 container m10L  ">
          <UsuariosResecTable list={att.usuarios}/>
        </div>
      </div>
    
    
    </div>
  )
    ;
};

export default Home;